import { POST_PUBLIC } from "../../api/api";

async function checkEmail(param) {
  try {
    const res = await POST_PUBLIC("check_email", param);
    return res;
  } catch (error) {
    console.error(error);
    return null;
  }
}
async function checkCity(param) {
  try {
    const res = await POST_PUBLIC("check_city", param);
    return res;
  } catch (error) {
    console.error(error);
    return null;
  }
}

async function booking(slug, param) {
  try {
    const res = await POST_PUBLIC(`event/booking/${slug}`, param);
    return res;
  } catch (error) {
    console.error(error);
    return null;
  }
}

export { checkEmail, checkCity, booking };
